//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        placeholderSrc: (
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAABaCAQAAACVz5XZAAAAiUlEQVR42u' +
            '3QQQ0AAAgEIK9/KZtpCF9uEIH0FAcRKFCgQIEIFChQIAIFChSIQIECBSJQoECBCBQoUCACBQoUiECBAg' +
            'UiUKBAgQgUKFAgAgUKFCgQgQIFCkSgQIECEShQoEAEChQoEIECBQpEoECBAhEoUKBABAoUKBCBAgUKRK' +
            'BAgQIFChQo8LMFVuOdgTgidTkAAAAASUVORK5CYII='
        ),
    },

    props: {
        photos: Array,
        ratio: {
            type: Number,
            default: 4 / 3,
        },
        n: {
            type: [Number, String],
            default: 3,
        },
        keyFn: Function,
        urlFn: Function,
        thumbUrlFn: Function,
        downloadFn: Function,
        removeFn: Function,
        groupKeyFn: Function,
        groupKeyCompareFn: Function,
        groupTitleFn: Function,
        useLightbox: Boolean,
        noScrimHide: Boolean,
        noEscHide: Boolean,
    },

    computed: {
        photoGroups() {
            if (!this.groupKeyFn)
                return [this.photos];

            const groups = _.groupBy(this.photos, this.groupKeyFn);
            const keys = Object.keys(groups);

            if (this.groupKeyCompareFn) {
                keys.sort(this.groupKeyCompareFn);
            }

            // Note: This relies on object key insertion order being maintained in practice
            return _.fromPairs(keys.map(d => [d, groups[d]]));
        },
    },

    methods: {
        openLightbox(photo) {
            if (this.useLightbox) {
                this.$refs.lightbox.open(photo);
            }
        },
    },
};
